var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",style:(("width: " + _vm.size + "; height: " + _vm.size + "; border: 4px solid " + _vm.baseColor + "; border-top: 4px solid #006BA8;"))})}
var staticRenderFns = []

export { render, staticRenderFns }